<ul *ngIf="getPageCount() > 0" class="pagination">
  <li class="page-item" [ngClass]="{ disabled: currentPage === 1 }">
    <a class="page-link" (click)="setPage(currentPage - 1)">{{
      previousLabel
    }}</a>
  </li>
  <li
    class="page-item"
    *ngFor="let page of getPageCountRange()"
    [ngClass]="{ active: currentPage === page }"
  >
    <a class="page-link" (click)="setPage(page)">{{ page }}</a>
  </li>
  <li
    class="page-item"
    [ngClass]="{ disabled: currentPage === getPageCount() }"
  >
    <a class="page-link" (click)="setPage(currentPage + 1)">{{ nextLabel }}</a>
  </li>
</ul>
